import { SERVICE_OGP_IMAGE, SITE_URL } from '../../constants'
import { withFaqPageSchema } from '../../builders/faq'
import { buildServiceSchema } from '../../builders/service'
import { designSystemFaqItems } from '../../data/faqs/design-system'
import { PageMeta } from '../../types'

const description = "デザイン原則の策定からFigmaコンポーネント設計・Reactライブラリ開発・ガイドライン整備まで、デザインシステムをフルスタックで構築します。チームが自走できる内製化支援にも対応。複数プロダクトのUI一貫性と開発効率を同時に高めます。"

export const designSystemPageMeta: PageMeta = {
  title: "デザインシステム構築・内製化支援 | Figma×React対応 | Aitria（アイトリア）",
  description,
  keyword: "デザインシステム figma スタイルガイド UIデザイン UIコンポーネント フロントエンド開発 内製化支援",
  image: SERVICE_OGP_IMAGE,
  url: `${SITE_URL}/services/studio/design-system/`,
}

const designSystemServiceSchema = buildServiceSchema({
  slug: "studio/design-system",
  name: "デザインシステム構築支援",
  description: designSystemPageMeta.description,
  serviceType: "デザインシステム構築支援",
  category: "STUDIO",
  offerCatalogName: "デザインシステム構築支援サービス",
  breadcrumbName: "デザインシステム構築支援",
  offers: [
    {
      name: "デザインシステム構築支援",
      description: "調査・ヒアリングから始め、デザイン基盤の策定やコンポーネント設計を経て、デザインシステムの開発を行います。より一層のプロダクト品質の向上やブランドの浸透、コスト削減を目指して、運用もサポートいたします。",
    }
  ],
})

export const designSystemSchema = withFaqPageSchema(
  designSystemServiceSchema,
  designSystemPageMeta.url,
  designSystemFaqItems,
)
